import { outboxMiddleware } from "@overmap-ai/core"
import { configureStore, type Store } from "@reduxjs/toolkit"

import { rootReducer } from "./reducers"
import type { RootState } from "./typings"

export const appStore: Store<RootState> = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			// TODO: optionally enable these based on env variables for debugging purposes?
			serializableCheck: false,
			immutableCheck: false,
		}).prepend(outboxMiddleware),
})
